import store from '@/store'
import router from '@/router'
import { RepositoryFactory } from "@/repositories/RepositoryFactory";

const UserRepository = RepositoryFactory.get("user");

const funcs = {

    defaultRoute() {
        let route = '/dashboard';
        if (store.state.auth.authenticated) {
            if (store.state.auth.permissions.includes('FEAT_MARKING_MANAGEMENT')) {
                route = '/markingmanagement';
            } else if (store.state.auth.permissions.includes('FEAT_MARK_PAPER')) {
                route = '/markapaper';                 
            } else if (store.state.auth.permissions.includes('FEAT_VIEW_ASSESSMENT_STRUCTURE')) {
                route = '/markingstructuremanager';                 
            }
        }
        return route;
    },

    getUser() {
        return store.state.auth.user;
    },

    hasPermission(feature) {
        let result = false;
        if (store.state.auth.permissions) {
            result = store.state.auth.permissions.includes(feature);
        }
        return result;
    },

    inMaintenanceMode() {
        return store.state.maintenance && !store.state.maintenanceUser;
    },

    isSignedIn() {
        return store.state.auth.authenticated;
    },

    decodeBase64(base64String) {
        const binaryString = atob(base64String);
        const binaryArray = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
            binaryArray[i] = binaryString.charCodeAt(i);
        }
        const utf8String = new TextDecoder('utf-8').decode(binaryArray);
    
        return utf8String
    },

    async signIn(token) {

        // decode base64 jwt token
        //const user = JSON.parse(Buffer.from(token.split(".")[1], 'base64').toString('utf8'));
        const user = JSON.parse(this.decodeBase64(token.split(".")[1]));
        store.commit("signIn", {
            user: user,
            token: token
        });     

        var { data } = await UserRepository.getClaims();

        if (data.success) {
            store.commit("setPermissions", data.data.permissions);            
        }  

    },

    signOut() {
        store.commit("setMaintenanceUser", false);   
        store.commit("signOut");
    }

}
export default funcs